import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import '../../App.css'
import serverUrl, { IMG_DEV_URL} from '../../constants/serverUrl';
import Hero from '../Hero/Hero';
import Hero2 from '../Hero2/Hero2';
import ArticleCard from '../AritcleCard/ArticalCard';
import ArticleCol from '../AritcleCol/ArticleCol';
import ArticleRow from '../ArticleRow/ArticleRow';
import HomeNav from '../HomeNav/HomeNav';

//const URI = 'http://localhost:8000';



export default class Home extends Component {

  render() {
    const { posts } = this.props;
    const mainBanner = posts.find(p => p.name === 'main_banner_white');
    const home_row1_col2 = posts.find(p => p.name === 'home_row1_col2');
    const latest_news = posts.find(p => p.name === 'latest_news');

    if(!mainBanner) {
      return <div/>
    }

    let home_row1_link = null;
    if (home_row1_col2.linkText && home_row1_col2.linkURL) {
      let style = {};
      if (home_row1_col2.linkColor && home_row1_col2.linkColor !== '#000000') {
        style.color = home_row1_col2.linkColor;
      }
      home_row1_link = <NavLink style={style} to={home_row1_col2.linkURL}>{home_row1_col2.linkText}</NavLink>
    }

    let latest_news_link = null;
    if (latest_news.linkText && latest_news.linkURL) {
      let style = {};
      if (latest_news.linkColor && latest_news.linkColor !== '#000000') {
        style.color = latest_news.linkColor;
      }
      latest_news_link = <NavLink style={style} to={latest_news.linkURL}>{latest_news.linkText}</NavLink>
    }
    const postHome1 = posts.find(p => p.name === 'home1');
    const postHome2 = posts.find(p => p.name === 'home2');
    const postHome3 = posts.find(p => p.name === 'home3');
    const postHome4 = posts.find(p => p.name === 'home4'); 

    const cards = [
      { title: postHome1.title, image: serverUrl + postHome1.image, body: postHome1.content, id: postHome1.id, link: postHome1.linkURL },
      { title: postHome2.title, image: serverUrl + postHome2.image, body: postHome2.content, id: postHome2.id, link: postHome2.linkURL  },
      { title: postHome3.title, image: serverUrl + postHome3.image, body: postHome3.content, id: postHome3.id, link: postHome3.linkURL  },
      { title: postHome4.title, image: serverUrl + postHome4.image, body: postHome4.content, id: postHome4.id, link: postHome4.linkURL  },
    ];
    const postmiddle = posts.find(p => p.name === 'homemiddle') || { name: 'homemiddle', image: '', title: 'no', content: 'no' };
    const postbottom1 = posts.find(p => p.name === 'homebottom1') || { name: 'homemiddle2', image: '', title: 'no', content: 'np' };
    const postbottom2 = posts.find(p => p.name === 'homebottom2') || { name: 'homemiddle2', image: '', title: 'no', content: 'np' };
    const title = "Helping people and businesses thrive in a cleaner, safer world.";
    const subtitle = "Smarter systems, cleaner spaces.";
    const btnText = "Search our range";
    return (
      <div>
        <Hero title={title} subtitle={subtitle} btnText={btnText} />
        <div className="container py-4">
          <div className="row g-4 py-4">
            {cards.map((card, index) => (
              <div className="col col-md-6 col-lg-3 col-xs-12 pt-2" key={index}>
                <ArticleCard title={card.title} image={card.image} body={card.body} id={card.id} link={card.link} />
              </div>
            ))}
          </div>
        </div>
        <Hero2 />
        <div className="container py-4">
          <div className="row g-4">
              <div className="col col-md-6 col-lg-6 col-xs-12 pt-2">
                <img src={serverUrl + postmiddle.image} 
                  alt={postmiddle.title} className="middleimg"
                  style={{width: '100%', height: 'auto'}}
                />
              </div>
              <div className="col col-md-6 col-lg-6 col-xs-12 pt-2">
                <ArticleCol title={postmiddle.title} body={postmiddle.content} id={postmiddle.id} link={postmiddle.linkURL} />
              </div>
          </div>
        </div>
        <div className="bg-gray-100">
          <div className="container py-4">
            <div className="row g-4">
              <div className="col col-md-6 col-lg-6 col-xs-12 pt-2">
                <ArticleRow title={postbottom1.title} image={postbottom1.image}
                  id={postbottom1.id}
                  isHTMLBody={true}
                  body={postbottom1.content}
                  titleColor={'#FFFFFF'}
                  bgColor={'#32c8d4'}
                  pColor={'#000000'}
                  linkColor={'#FFFFFF'}
                  link={postbottom1.linkURL}
                />
              </div>
              <div className="col col-md-6 col-lg-6 col-xs-12 pt-2">
                <ArticleRow title={postbottom2.title}
                id={postbottom2.id}
                image={postbottom2.image} body={postbottom2.content}
                  isHTMLBody={true}
                  titleColor={'#32c8d4'} bgColor={'#5a2684'} pColor={'#FFFFFF'} linkColor={'#32c8d4'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// src/components/pages/Home.js